import store from '@/store'

/**
 * @Description 判断教师是否展示 - 学员权益包管理菜单
 * @returns { Boolean }
 */
export function getStudentRight() {
  const { roles } = store.state.userInfo.userInfo
  // 有权益包的角色【超级管理员，管理员，教务，招生负责人，前台】
  const hasRightRoleArr = ['super_manager', 'manage', 'jiaowu', 'admissions_officer', 'kefu']
  const roleIntersection = roles && roles.filter(role => hasRightRoleArr.indexOf(role) != -1) // 取交集
  return roleIntersection && roleIntersection.length > 0
}